<script lang="ts">
    import {nouns} from './nouns';
    import ListItem from '$lib/components/word-list/list-item.svelte';
    import CtaDividers from '$lib/components/word-list/cta-dividers.svelte';
    import {buildJsonLd} from '$lib/utils/build-json-ld';
    import EndBlock from '$lib/components/word-list/EndBlock.svelte';
</script>

<svelte:head>
    <title>100 Most Common German Nouns | Master German Vocabulary</title>
    <meta name="description"
          content="Dive into the German language by mastering the 100 frequent nouns. This list will aid you in building a strong vocabulary foundation.">

    {@html `<script type="application/ld+json">${buildJsonLd('100 Most Common German Nouns', nouns)}</script>`}
</svelte:head>

<div class="word-list-article card">
    <h1>
        100 Most Common German Nouns (with example sentences)
    </h1>
    <p>
        When learning the German language, building a strong vocabulary is essential. Among the most important words to
        learn are the most common German nouns, as they appear frequently and form the backbone of everyday
        communication. By mastering these key nouns, you’ll greatly improve your ability to understand and participate
        in typical conversations.
    </p>
    <p>
        In this guide, we’ve compiled a word list of the 100 most frequently used nouns in the German language. Each
        entry comes with its English meaning and an example sentence to show how the word can be used in context.
        Whether you’re a beginner or looking to enhance your existing knowledge, these essential words will help you
        navigate a wide range of situations and build a solid foundation for your German vocabulary.
    </p>
    <h2>
        Top 100 Essential German Nouns
    </h2>

    <div class="word-list">
        {#each nouns as noun, index}
            <ListItem {...noun}/>
            <CtaDividers
                    numberOfItems={nouns.length}
                    index={index}
            />
        {/each}
    </div>

    <EndBlock
            whatThisPageIsAbout={'the 100 most common German nouns'}
            link1={{url: '100-most-common-german-verbs', text: '100 most common German verbs'}}
            link2={{url: '100-most-common-german-adjectives', text:'100 most common German adjectives'}}
    />
</div>